import React, { useCallback, useRef } from 'react';
import { FiLock, FiMail } from 'react-icons/fi';
import { FaPaw } from 'react-icons/fa';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import getValidationErrors from '../../utils/getValidationErrors';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import Input from '../../components/Input';
import Button from '../../components/Button';

import { Field, FormCard, Header, Links, Orbs, Page, Wrap } from './styles';

interface SignInFormData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const { signIn } = useAuth();
  const { addToast } = useToast();

  const handleSubmit = useCallback(
    async (data: SignInFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: data.email,
          password: data.password,
        });

        history.push('/');
      } catch (err: any) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          addToast({
            type: 'error',
            title: 'Erro no login',
            description: 'Verifique e-mail e senha e tente novamente.',
          });

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro no login',
          description:
            err?.response?.data?.message || 'Não foi possível entrar.',
        });
      }
    },
    [addToast, history, signIn],
  );

  return (
    <Page className="particles-bg">
      <Orbs>
        <div className="orb primary" />
        <div className="orb sky" />
      </Orbs>

      <Wrap>
        <Header>
          <div className="paw" aria-hidden="true">
            <FaPaw size={28} />
          </div>
          <h1>Bem-vindo de volta!</h1>
          <p>Entre na sua conta para continuar</p>
        </Header>

        <FormCard className="glass-strong">
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Field className="first">
              <label htmlFor="email">E-mail</label>
              <Input
                id="email"
                name="email"
                icon={FiMail}
                placeholder="seu@email.com"
              />
            </Field>

            <Field>
              <label htmlFor="password">Senha</label>
              <Input
                id="password"
                name="password"
                icon={FiLock}
                placeholder="••••••••"
                type="password"
              />
            </Field>

            <div style={{ marginTop: 18 }}>
              <Button type="submit" fullWidth>
                Entrar
              </Button>
            </div>
          </Form>
        </FormCard>

        <Links>
          <Link to="/forgot" className="muted">
            Esqueci minha senha
          </Link>

          <p className="muted">
            Não tem uma conta?{' '}
            <Link to="/signup" className="sky">
              Cadastre-se
            </Link>
          </p>

          <Link to="/resend-verify-email">Reenviar validação de e-mail</Link>
        </Links>
      </Wrap>
    </Page>
  );
};

export default SignIn;
